import React from 'react';
import cx from 'classnames';

import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { buildContentfulAssetUrl } from 'ha/utils/buildContentfulAssetUrl';
import { H1 } from 'ha/ui.legacy/Headers';
import { LandingBlogData } from '../types';
import { BlogContent as BlogLandingContent } from './BlogLandingContent';

interface Props {
  data: LandingBlogData;
}

const IMAGE_ASSET_HEIGHT = 1000;
const IMAGE_ASSET_WIDTH = 1600;

const backgroundImage = (url: string) => {
  return `url(${buildContentfulAssetUrl(url, {
    width: IMAGE_ASSET_WIDTH,
    height: IMAGE_ASSET_HEIGHT,
  })})`;
};

const BlogLandingMain: React.FC<Props> = ({ data }) => {
  const backgroundUrl = data.headerImageAsset?.fields.url || data.headerImage;
  const { md } = useMediaQuery();

  return (
    <div>
      <div className="relative flexbox flex-justify-center">
        <div
          style={{
            backgroundImage: backgroundUrl
              ? backgroundImage(backgroundUrl)
              : undefined,
          }}
          className="block-cover z-index-0"
        />
        <H1
          className={cx(
            'color-white line-height-twice m-b-0 m-y-5 text-center z-index-2',
            md ? 'w-50 font-size-xl' : 'p-x-1',
          )}
        >
          <span
            className={cx(
              'box-decoration-break-clone back-dark-orange',
              md ? 'p-a-0_75' : 'p-a-0_5',
            )}
          >
            {data.title}
          </span>
        </H1>
      </div>
      <div
        className={cx(
          'flexbox flex-justify-center m-y-5',
          md ? 'm-x-5' : 'm-x-2',
        )}
      >
        <div className="blog-landing--content w-100">
          <BlogLandingContent data={data} />
        </div>
      </div>
    </div>
  );
};

export { BlogLandingMain };
